<template>
	<o-card
		title="Évolution de votre rémunération"
		class="card--dashboard-salary-current-year">
		<div :ref="setup._chart"/>

		<o-loader
			color="brand"
			size="md"
			:visible="!setup.dataLoaded"/>
	</o-card>
</template>

<script setup lang="ts">
import DashboardTempWorkerSalaryCurrentYearCardSetupService from '@/setup/dashboard/temp-worker/DashboardTempWorkerSalaryCurrentYearCardSetupService';
type Emits = { (e: 'hide'): void }
const emits = defineEmits<Emits>();
const setup = new DashboardTempWorkerSalaryCurrentYearCardSetupService(emits);
</script>
